import MiniAppHeader from "../components/MiniAppHeader";
import { colors } from "../theme";
import WaveSection from "../components/WaveSection";
import ContactUs from "../components/ContactUs";
import OurGoal from "../components/Ourgoal";
import MyFooter from "../components/MyFooter";
import AboutAds from "../components/AboutAds";
import useMetaTags from "../utils/useMetaTags";

const TelegramAds = () => {
  useMetaTags(
    "Telegram Ads Agency | Maximize your ROI",
    "Achieve the best results from your Telegram Ads with our experts guiding you to grow on Telegram.",
  );

  return (
    <div style={{ backgroundColor: colors.background }} id="container">
      <MiniAppHeader isAds />
      <WaveSection isAds />
      <AboutAds />
      <ContactUs />
      <OurGoal />
      <MyFooter />
    </div>
  );
};
export default TelegramAds;
